export default __webpack_public_path__ + "static/media/comparison-BG.54ec553e.mp4";